import { render } from "./BaseRadioButton.vue?vue&type=template&id=d1251088&scoped=true"
import script from "./BaseRadioButton.vue?vue&type=script&lang=js"
export * from "./BaseRadioButton.vue?vue&type=script&lang=js"

import "./BaseRadioButton.vue?vue&type=style&index=0&id=d1251088&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1251088"]])

export default __exports__